<template lang="pug">
  .columns
    .column.is-12
      .columns
        .column.is-12
          h4.title.is-5 Artículos para salida
      .columns
        .column.is-12
          TbAceptarItemsAsignacionCons(:items="items" :salida="salida" @saveItem="saveItem" @deleteItem="deleteItem" @saveObs='saveObs')
</template>

<script>
  import TbAceptarItemsAsignacionCons from './TbAceptarItemsAsignacionCons.vue'
  import InventarioServices from '../../services/inventario/inventario'

  export default {
    name: 'ContainerItemsAsigancionesCons',
    components: { TbAceptarItemsAsignacionCons },
    props: {
      salida: {
        type: Object,
        default: () => {}
      },
      items: {
        type: Array,
        default: []
      },
    },
    data() {
      return {
        itemsAceptados: []
      }
    },
    watch: {
      itemsAceptados() {
        this.$emit('itemsAceptados', this.itemsAceptados)
      }
    },
    methods: {
      saveItem (data) {
        InventarioServices.aceptarItemCons_Asignaciones(data.id, data.cantRecibida, this.salida.estado)
          .then((resp) => {
            if (resp.success) {
              this.itemsAceptados.push(data)
              this.displayToast(`${resp.respuesta}`, 'done', 'Ok')
            } else {
              this.displayToast(`${resp.respuesta}`, 'ban', 'Ok')
            }
          })
          .catch((e)=> this.displayToast(e.message,'ban','Ok'))
      },
      saveObs (data) {
        console.log(this.salida.estado)
        InventarioServices.updateObservacionItemCons_Asignaciones(data.id, data.observacion, this.salida.estado)
          .then((resp) => {
            if (resp.success) {
              this.displayToast(`${resp.respuesta}`, 'done', 'Ok')
            } else {
              this.displayToast(`${resp.respuesta}`, 'ban', 'Ok')
            }
          })
          .catch((e)=> this.displayToast(e,'ban',''))
      },
      deleteItem (item) {
        console.log(item)
        this.displayToast(item.text, item.icon, item.actionText)
        this.$emit('refreshItems', true)
      },
      displayToast(text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: "toasted-primary", 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/ContainerItemsAsignacionesCons.vue